let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("41UB0")).then(() => parcelRequire('0AnmB'));